import { useTranslation } from 'react-i18next';

/**
 * Index for `/admin`. A franchise-administration landing; the individual admin pages (Users,
 * Roles, Audit, Brand, Country Policies, Venues, Employees) hang off the admin shell's nav.
 */
export function AdminHome() {
  const { t } = useTranslation('common');
  return (
    <section className="grid gap-2 p-6">
      <h1 className="text-2xl font-semibold">{t('admin.homeTitle')}</h1>
      <p className="text-muted-foreground">{t('admin.homeBody')}</p>
    </section>
  );
}
